import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppRoutingModule } from "../app-routing.module";
import { AuthLayoutComponent } from "./auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { MainFooterComponent } from "./main-layout/main-footer/main-footer.component";
import { MainHeaderComponent } from "./main-layout/main-header/main-header.component";
import { TransparenciaLayoutComponent } from "./transparencia-layout/transparencia-layout.component";
import { TransparenciaHeaderComponent } from "./transparencia-layout/transparencia-header/transparencia-header.component";
import { TransparenciaFooterComponent } from "./transparencia-layout/transparencia-footer/transparencia-footer.component";
import { LucideAngularModule, icons } from 'lucide-angular';
import { MainSidebarComponent } from './main-layout/main-sidebar/main-sidebar.component';
import { TrocarClienteComponent } from './main-layout/trocar-cliente/trocar-cliente.component';
import { MeuPerfilComponent } from './main-layout/meu-perfil/meu-perfil.component';
import { ConfiguracoesComponent } from './main-layout/configuracoes/configuracoes.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AcessibilidadePortalComponent } from './transparencia-layout/acessibilidade-portal/acessibilidade-portal.component';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SharedModule } from "../_shared";
import { NotificacoesComponent } from './main-layout/notificacoes/notificacoes.component';
import { NotificacoesHistoricoDialogComponent } from './main-layout/notificacoes/notificacoes-historico-dialog/notificacoes-historico-dialog.component';
import { NotificacoesDetalhesComponent } from './main-layout/notificacoes/notificacoes-detalhes/notificacoes-detalhes.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    MainHeaderComponent,
    MainFooterComponent,
    AuthLayoutComponent,
    TransparenciaLayoutComponent,
    TransparenciaHeaderComponent,
    TransparenciaFooterComponent,
    MainSidebarComponent,
    TrocarClienteComponent,
    MeuPerfilComponent,
    ConfiguracoesComponent,
    AcessibilidadePortalComponent,
    NotificacoesComponent,
    NotificacoesHistoricoDialogComponent,
    NotificacoesDetalhesComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LucideAngularModule,
    LucideAngularModule.pick(icons),
    OrganizationChartModule,
    MatAutocompleteModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: []
})

export class LayoutModule { }